import { Button, FormInput, FormRoot, FormTextarea } from "@devhop/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import * as RHF from "react-hook-form";
import { z } from "zod";
import type {
  CreateContractTypeFormDTO,
  UpdateContractTypeFormDTO,
} from "../../domain/contract-types";

const ContractTypeFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່"),
  description: z.string().nullable().optional(),
  orderIndex: z.number().int().default(0),
  isActive: z.boolean().optional(),
});

type ContractTypeFormValues = z.input<typeof ContractTypeFormSchema>;

export function ContractTypeForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<ContractTypeFormValues>;
  onSubmit: (
    values: CreateContractTypeFormDTO | UpdateContractTypeFormDTO,
  ) => void;
  submitting?: boolean;
}) {
  const defaultValues: ContractTypeFormValues = {
    name: "",
    description: "",
    orderIndex: 0,
    isActive: true,
    ...initialValues,
  };

  const methods = RHF.useForm<ContractTypeFormValues>({
    resolver: zodResolver(ContractTypeFormSchema),
    defaultValues,
  });

  return (
    <FormRoot<ContractTypeFormValues>
      methods={methods}
      onSubmit={(vals) => {
        const base = {
          name: vals.name,
          description: vals.description && vals.description.trim() !== "" ? vals.description : null,
          orderIndex: vals.orderIndex ?? 0,
        };
        
        // For update, convert boolean isActive to string if provided
        if (initialValues && vals.isActive !== undefined) {
          onSubmit({
            ...base,
            isActive: vals.isActive ? "true" : "false",
          } as UpdateContractTypeFormDTO);
        } else {
          onSubmit(base as CreateContractTypeFormDTO);
        }
      }}
      className="space-y-4"
    >
      <FormInput
        name="name"
        label="ຊື່ປະເພດສັນຍາ"
        placeholder="ຕົວຢ່າງ: ສັນຍາຈ້າງພະນັກງານ"
        requiredMark
      />
      <FormTextarea
        name="description"
        label="ຄຳອະທິບາຍ"
        placeholder="ບໍ່ບັງຄັບ"
        rows={3}
      />
      <div className="flex justify-end gap-2">
        <Button type="submit" isLoading={submitting}>
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
